import styled from 'styled-components'

const Section = styled.section`
  display: flex;
  min-height: 100%;
`

export default Section



// WEBPACK FOOTER //
// ./src/components/views/layout/Section.js